/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { LoginCredentialConverter } from './converters';
import { LoginCredentialHashedConverter } from './converters';
import { SecurityOptionsConverter } from './converters';
import { NfcPairingMode } from './models';
import { WirelessPairingOptionsConverter } from './converters';
import { LowPowerOptimizationLevel } from './models';
import { CpuFrequencyOptionsConverter } from './converters';
import { PowerOptimizationOptionsConverter } from './converters';
import { ServiceCode } from './models';
import { NetworkOptionsConverter } from './converters';
import { NfcConnectionPriority } from './models';
import { ProtocolMaxFrameSizeConverter } from './converters';
import { MultiRequestFrameConverter } from './converters';
import { MultiResponseFrameConverter } from './converters';

export const loginCredential = new LoginCredentialConverter();

export const loginCredentialHashed = new LoginCredentialHashedConverter();

export const securityOptions = new SecurityOptionsConverter();

export const nfcPairingMode = createEnumConverter<NfcPairingMode>(
  NfcPairingMode,
  1,
);

export const nfcPairingModeArray = createEnumArrayConverter<NfcPairingMode>(
  NfcPairingMode,
  1,
);

export const wirelessPairingOptions = new WirelessPairingOptionsConverter();

export const lowPowerOptimizationLevel =
  createEnumConverter<LowPowerOptimizationLevel>(LowPowerOptimizationLevel, 1);

export const lowPowerOptimizationLevelArray =
  createEnumArrayConverter<LowPowerOptimizationLevel>(
    LowPowerOptimizationLevel,
    1,
  );

export const cpuFrequencyOptions = new CpuFrequencyOptionsConverter();

export const powerOptimizationOptions = new PowerOptimizationOptionsConverter();

export const serviceCode = createEnumConverter<ServiceCode>(ServiceCode, 1);

export const serviceCodeArray = createEnumArrayConverter<ServiceCode>(
  ServiceCode,
  1,
);

export const networkOptions = new NetworkOptionsConverter();

export const nfcConnectionPriority = createEnumConverter<NfcConnectionPriority>(
  NfcConnectionPriority,
  1,
);

export const nfcConnectionPriorityArray =
  createEnumArrayConverter<NfcConnectionPriority>(NfcConnectionPriority, 1);

export const protocolMaxFrameSize = new ProtocolMaxFrameSizeConverter();

export const multiRequestFrame = new MultiRequestFrameConverter();

export const multiResponseFrame = new MultiResponseFrameConverter();
